import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { COLORS } from '@/lib/constants/colors'
interface IDatePickerProps {
  value?: Date | null
  onChange: (date: Date | null) => void
}

export default function DatePicker({ value, onChange }: IDatePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        format="dd/MM/yyyy"
        sx={{
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${COLORS.GREY.DEFAULT}`,
          },
        }}
        value={value ?? null}
        onChange={onChange}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
          },
        }}
      />
    </LocalizationProvider>
  )
}
